<div class="ngtw-bar-line-chart fw fh">
    <div class="header">
        <h4 *ngIf="graphType === 'oee'" class="ellipses  d-flex" title="Cost % vs OEE">Cost % vs OEE
            &nbsp;
            <div [popover]="popTemplate" triggers="mouseenter:mouseleave" container="body" placement="bottom">

                <img src="../../../assets/images/icn-info.svg" alt="">
            </div>
        </h4>
        <h4 *ngIf="graphType === 'changeOver'" class="ellipses d-flex" title="Changeover vs Cost %">Changeover vs Cost %
            &nbsp;
            <div [popover]="popTemplate1" triggers="mouseenter:mouseleave" container="body" placement="bottom">

                <img src="../../../assets/images/icn-info.svg" alt="">
            </div>
        </h4>
        <div *ngIf="graphType === 'oee'" class="full-screen" (click)='showPopupOEE()' (keydown.enter)="showPopupOEE()"
            (keydown.space)="showPopupOEE()"></div>
        <div *ngIf="graphType === 'changeOver'" class="full-screen" (click)='showPopupChangeOver()'
            (keydown.enter)="showPopupChangeOver()" (keydown.space)="showPopupChangeOver()"></div>
    </div>
    <ng-container *ngIf="graphType === 'oee'">
        <div #lineGraphDiv class="graph-div" id="lineGraphDiv"></div>
    </ng-container>
    <ng-container *ngIf="graphType === 'changeOver'">
        <div #barGraphDiv class="graph-div" id="barGraphDiv"></div>
    </ng-container>

</div>
<ng-template #popTemplate>
    <div class="mb-15">Monthly trend of Overall Equipment Efficiency (OEE) against Cost % at the Line level</div>

    <div class="tooltip-formula">
        <div class="tooltip-left">
            Cost % =
        </div>
        <div class="tooltip-center">
            <div class="tooltip-center-top">
                total waste cost generated by the Line per month

            </div>
            <hr class="tooltip-center-middle">
            <div class="tooltip-center-bottom">
                total waste cost generated by the Line from Year to Date
            </div>

        </div>
        <div class="tooltip-right">
            * 100
        </div>
    </div>

</ng-template>
<ng-template #popTemplate1>
    <div class="mb-15">Monthly trend of Format Changeover and Product Changeover against Cost % at the Line level</div>

    <div class="tooltip-formula">
        <div class="tooltip-left">
            Cost % =
        </div>
        <div class="tooltip-center">
            <div class="tooltip-center-top">
                total waste cost generated by the Line per month

            </div>
            <hr class="tooltip-center-middle">
            <div class="tooltip-center-bottom">
                total waste cost generated by the Line from Year to Date
            </div>

        </div>
        <div class="tooltip-right">
            * 100
        </div>
    </div>

</ng-template>